import { User } from '../../../models';

import { redirectTo, Preloader, ErrorsModal } from '../../../utils';
import Radio from 'backbone.radio';
import { LeagueTableView, LeagueRowView } from '../../components';

const joinChannel   = Radio.channel( 'join' );
const globalChannel = Radio.channel( 'global' );

/**
 * @desc Core League Join View Class
 */
export default class CoreLeagueJoinView extends LeagueTableView {
	viewComparator( a_model, b_model ) {
		let val_a = a_model.get( 'num_teams' ),
			val_b = b_model.get( 'num_teams' );

		if ( this.order_by === 'num_teams_desc' ) {
			if ( val_a > val_b ) {
				return -1; // before
			}
			if ( val_b > val_a ) {
				return 1; // after
			}
		}
		else {
			if ( val_a < val_b ) {
				return -1; // before
			}
			if ( val_b < val_a ) {
				return 1; // after
			}
		}
	}

	get childView() {
		return LeagueRowView;
	}

	get className() {
		return "";
	}

	/**
	 * Set all UI for this view
	 * @returns object
	 */
	ui() {
		return {
			join_to_league: '.join-to-league',
			load_more:      '.js-load-more'
		};
	}

	/**
	 * Create events for this UI
	 * @returns object
	 */
	events() {
		return {
			'click @ui.join_to_league': 'joinToLeague',
			'click @ui.load_more':      'loadMore'
		};
	}

	/**
	 * Set model events
	 * @returns object
	 */
	modelEvents() {
		return {
			'league:join:errors':  'joinLeagueError',
			'league:join:success': 'joinLeagueSuccess'
		};
	}

	get childViewOptions() {
		return {
			type_page: 'join',
			user:      this.user,
			rounds:    this.rounds
		}
	}

	get leaguesLimit() {
		return 20;
	}

	/**
	 * Initialize view data
	 */
	initialize() {
		this.offset   = 0;
		this.order_by = 'num_teams_desc';
		this.user     = User;
		this.q        = '';
		this.remove   = true;
		this.rounds   = this.getOption( 'rounds' );

		this.model.set( {
			leagues:      {},
			is_show_more: false
		} );

		Preloader.show();
		this.checkJoinByPin()
			.initListeners()
			.updatePageData();
		Preloader.hide();
	}

	initListeners() {
		this.listenTo( joinChannel, 'join:to:league', this.joinLeagueByPin );
		this.listenTo( joinChannel, 'join:order:by', this.sortByTeam );
		this.listenTo( joinChannel, 'join:filter:by', this.searchLeagueBy );
		this.listenTo( joinChannel, 'search:by:pin:league', this.searchLeagueByPin );
		this.listenTo( globalChannel, 'click:load:more', this.showMore );
		this.listenTo( this.collection, 'get:response:leagues:count', this.isShowMoreButton );

		return this;
	}

	/**
	 * Get all base data for this class
	 * @returns {*|Promise.<Object>}
	 */
	fetchData() {
		let data = {
			q:           this.q,
			order_by:    'num_teams_desc',
			offset:      this.offset,
			filter:      this.model.get( 'filter' )
		};

		return this.collection.showJoinList( data, this.remove );
	}

	/**
	 *
	 */
	updateView() {
		this.render();
	}

	/**
	 *
	 * @param {string} code
	 */
	joinLeagueByPin( code ) {
		this.model.join( code );
	}

	/**
	 *
	 * @param {object} element
	 */
	joinToLeague( element ) {
		let code       = $( element.currentTarget ).data( 'code' );
		this.league_id = $( element.currentTarget ).data( 'id' );
		this.model.join( code );
	}

	/**
	 *
	 * @param {object} errors
	 */
	joinLeagueError( errors ) {
		ErrorsModal.show( errors );
	}

	/**
	 *
	 */
	joinLeagueSuccess( response ) {
		let league_id = response.id;

		let url = `fantasy/league/${league_id}/manage`;
		redirectTo( url );
	}

	/**
	 *
	 * @param {object} data
	 */
	searchLeagueBy( data ) {
		this.model.clearFilters()
			.filterBy( data.key, data.val );
		return this.clearShowMoreCounter().updatePageData();
	}

	searchLeagueByPin( code ) {
		this.q = code;
		return this.clearShowMoreCounter().updatePageData();
	}

	sortByTeam() {
		this.order_by = (this.order_by === 'num_teams_desc') ? 'num_teams' : 'num_teams_desc';
		return this.clearShowMoreCounter().updatePageData();
	}

	isShowMoreButton( count_leagues ) {
		let is_load_more = count_leagues >= this.leaguesLimit;
		globalChannel.trigger( 'is:show:load:more', is_load_more );
		return this;
	}

	showMore() {
		this.offset = this.offset + this.leaguesLimit;
		this.remove = false;
		return this.updatePageData();
	}

	checkJoinByPin() {
		let code = this.getOption( 'code' );

		if( code ) {
			this.joinLeagueByPin( code );
		}

		return this;
	}

	clearShowMoreCounter() {
		this.remove = true;
		this.offset = 0;
		return this;
	}

	async updatePageData() {
		await this.fetchData();
		this.updateView();
	}
}